import { APP_INITIALIZER, InjectionToken, Type } from '@angular/core';

import { IframeCommService } from './iframe-comm.service';

export const IFRAME_MESSAGE_HANDLERS = new InjectionToken<Type<any>[]>('IFRAME_MESSAGE_HANDLERS');

export const IframeCommProvider = {
	provide: APP_INITIALIZER,
	useFactory: (_service: IframeCommService) => () => {},
	deps: [IframeCommService],
	multi: true,
};
